/* eslint-disable */
import { useState } from 'react';
import { userService } from '../services/userService';
import { LearnerAchievements } from '../types/user';

export function useLearnerAchievements() {
	const [achievements, setAchievements] =
		useState<LearnerAchievements | null>(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchAchievements = async (learnerId: string) => {
		if (!learnerId) return;

		setLoading(true);
		setError(null);

		try {
			const data = await userService.getLearnerAchievements(learnerId);
			setAchievements(data);
		} catch (err: any) {
			console.error('Error fetching learner achievements:', err);
			setError(err.message || 'Failed to fetch learner achievements');
		} finally {
			setLoading(false);
		}
	};

	return {
		achievements,
		loading,
		error,
		fetchAchievements,
	};
}
